import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const getImageUrl = async (token) => {
  console.log(`${BACKEND_URL}api/upload/image`);
  const config = { headers: { authorization: `Bearer ${token}` } };
  const response = axios.get(`${BACKEND_URL}api/upload/image`, config);
  return response;
};

const resolveImageContentType = (data) => {
  if (data?.type && String(data.type).startsWith("image/")) {
    return data.type === "image/*" ? "image/jpeg" : data.type;
  }
  const name = String(data?.name || "").toLowerCase();
  if (name.endsWith(".png")) return "image/png";
  if (name.endsWith(".gif")) return "image/gif";
  if (name.endsWith(".webp")) return "image/webp";
  if (name.endsWith(".svg")) return "image/svg+xml";
  return "image/jpeg";
};

const uploadImage = async (uri, data) => {
  const config = {
    headers: {
      "Content-Type": resolveImageContentType(data),
      "x-amz-acl": "public-read",
    },
  };
  const response = await axios.put(uri, data, config);
  return response;
};

const deleteImage = async (token, data) => {
  const response = await axios.delete(`${BACKEND_URL}api/upload/image`, {
    headers: { authorization: `Bearer ${token}` },
    data,
  });
  return response;
};

const uploadLocalImage = async (token, file) => {
  const formData = new FormData();
  formData.append("image", file);
  const response = await axios.post(`${BACKEND_URL}api/bank-infos/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      authorization: `Bearer ${token}`,
    },
  });
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  uploadImage,
  deleteImage,
  getImageUrl,
  uploadLocalImage,
};
